import React from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { appData } from '../../../../data/portfolioData';
import './Footer.css';

const Footer = () => {
  const { getText, currentLanguage } = useLanguage();

  const currentYear = new Date().getFullYear();

  const socialIcons = {
    'GitHub': '🐙',
    'LinkedIn': '💼',
    'Email': '📧',
    'WhatsApp': '💬',
    'Instagram': '📸',
    'Twitter': '🐦'
  };

  const quickLinks = [
    { name: getText('portfolio.nav.home'), href: '#hero' },
    { name: getText('portfolio.nav.projects'), href: '#projects' },
    { name: getText('portfolio.nav.skills'), href: '#skills' },
    { name: getText('portfolio.nav.experience'), href: '#experience' },
    { name: getText('portfolio.nav.services'), href: '#services' },
    { name: getText('portfolio.nav.contact'), href: '#contact' }
  ];

  const services = [
    getText('portfolio.services.frontend'),
    getText('portfolio.services.backend'),
    getText('portfolio.services.fullstack'),
    getText('portfolio.services.ecommerce'),
    'Landing Pages',
    getText('portfolio.footer.technicalConsulting')
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <div className="brand-logo">
              <span className="logo-icon">👨‍💻</span>
              <div className="brand-text">
                <h3 className="brand-name">{appData.personal.name}</h3>
                <p className="brand-title">{getText('portfolio.footer.profession')}</p>
              </div>
            </div>
            
            <p className="brand-description">
              {getText('portfolio.footer.description')}
            </p>

            <div className="social-links">
              {appData.social && appData.social.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  title={`${getText('portfolio.footer.follow')} ${item.platform}`}
                >
                  <span className="social-icon">{socialIcons[item.platform] || '🔗'}</span>
                  <span className="social-name">{item.platform}</span>
                </a>
              ))}
            </div>

            <div className="quick-links-section" hidden>
              <h4 className="section-title">{getText('portfolio.footer.quickLinks')}</h4>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className="footer-link">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="footer-section footer-contact">
            <h4 className="section-title">{getText('portfolio.contact.title')}</h4>
            
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <div className="contact-details">
                  <span className="contact-label">Email</span>
                  <a 
                    href={`mailto:${appData.personal.email}`} 
                    className="contact-value"
                  >
                    {appData.personal.email}
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon">📱</span>
                <div className="contact-details">
                  <span className="contact-label">WhatsApp</span>
                  <a 
                    href={appData.personal.whatsapp} 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-value"
                  >
                    {appData.personal.phone}
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <div className="contact-details">
                  <span className="contact-label">{getText('portfolio.contact.location')}</span>
                  <span className="contact-value">
                    {appData.personal.location.full}
                  </span>
                </div>
              </div>
            </div>

            <div className="quick-contact">
              <h5>{getText('portfolio.contact.quickContact.title')}</h5>
              <div className="contact-buttons">
                <a
                  href={`mailto:${appData.personal.email}?subject=${getText('portfolio.contact.quickContact.emailSubject')}`}
                  className="contact-btn email-btn"
                >
                  <span>📧</span>
                  {getText('portfolio.contact.email')}
                </a>
                <a
                  href={`${appData.personal.whatsapp}?text=${getText('portfolio.contact.quickContact.whatsappMessage')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-btn whatsapp-btn"
                >
                  <span>💬</span>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>
                © {currentYear} {appData.personal.name}. {getText('portfolio.footer.rights')}
              </p>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;